export const SITE_URL = 'https://tavernix.io';

const buildServiceJsonLd = (name, description) => ({
  '@context': 'https://schema.org',
  '@type': 'Service',
  name,
  provider: {
    '@type': 'Organization',
    name: 'Tavernix',
    url: SITE_URL,
  },
  description,
  areaServed: 'US',
});

/**
 * Single source of truth for the services index cards, route slugs, and the
 * per-page SEO metadata (title / meta description / canonical / JSON-LD).
 * Page bodies live in their own components; this keeps cards and pages in sync.
 */
export const services = [
  {
    slug: 'software-web-development',
    cardTitle: 'Software / Web Development',
    breadcrumb: 'Software & Web Development',
    updated: 'Updated June 2026',
    cardDescription:
      'Custom software, SaaS platforms, mobile apps, e-commerce, and web hosting built for modern businesses.',
    seo: {
      title: 'Software & Web Development | Tavernix',
      description:
        'Custom software, SaaS platforms, mobile apps (iOS & Android), e-commerce, and web hosting built for modern businesses.',
      canonical: `${SITE_URL}/services/software-web-development`,
      jsonLd: buildServiceJsonLd(
        'Software & Web Development',
        'Custom software, SaaS platforms, mobile apps (iOS & Android), e-commerce, and web hosting built for modern businesses.'
      ),
    },
  },
  {
    slug: 'cybersecurity',
    cardTitle: 'Cybersecurity',
    breadcrumb: 'Cybersecurity',
    updated: 'Updated June 2026',
    cardDescription:
      'Security audits, penetration testing, vulnerability assessments, and data protection for organizations.',
    seo: {
      title: 'Cybersecurity Services | Tavernix',
      description:
        'Security audits, penetration testing, vulnerability assessments, and data protection for businesses and organizations.',
      canonical: `${SITE_URL}/services/cybersecurity`,
      jsonLd: buildServiceJsonLd(
        'Cybersecurity Services',
        'Security audits, penetration testing, vulnerability assessments, and data protection for businesses and organizations.'
      ),
    },
  },
  {
    slug: 'managed-it-smb',
    cardTitle: 'Managed IT for SMBs',
    breadcrumb: 'Managed IT',
    updated: 'Updated June 2026',
    cardDescription:
      'Proactive monthly IT support for small businesses in NY & NJ. We handle your infrastructure (remote and on-site) so you never have to think about it.',
    seo: {
      title: 'Managed IT for Small Businesses | Tavernix, NY & NJ',
      description:
        'Proactive monthly IT support for small businesses in New York and New Jersey. Remote and on-site infrastructure management, no IT headaches.',
      canonical: `${SITE_URL}/services/managed-it-smb`,
      jsonLd: buildServiceJsonLd(
        'Managed IT for Small Businesses',
        'Proactive monthly IT support for small businesses in New York and New Jersey. Remote and on-site infrastructure management, no IT headaches.'
      ),
    },
  },
  {
    slug: 'cloud-services',
    cardTitle: 'Cloud Services',
    breadcrumb: 'Cloud Services',
    updated: 'Updated June 2026',
    cardDescription:
      'Cloud computing, backup and disaster recovery, cloud migration, and scalable virtualization resources.',
    seo: {
      title: 'Cloud Services & Infrastructure | Tavernix',
      description:
        'Cloud computing, backup solutions, disaster recovery, and cloud migration for businesses. AWS, managed hosting, and scalable infrastructure.',
      canonical: `${SITE_URL}/services/cloud-services`,
      jsonLd: buildServiceJsonLd(
        'Cloud Services & Infrastructure',
        'Cloud computing, backup solutions, disaster recovery, and cloud migration for businesses. AWS, managed hosting, and scalable infrastructure.'
      ),
    },
  },
];

export const getService = (slug) => services.find((service) => service.slug === slug);

export const INDEX_SEO = {
  title: 'Services | Tavernix',
  description:
    "Explore Tavernix's full range of technology services: software development, cybersecurity, managed IT, and cloud services.",
  canonical: `${SITE_URL}/services`,
};
